module.exports = __webpack_public_path__ + "static/media/cipia-logo.3e9bfa83.png";